module.exports = __webpack_public_path__ + "static/media/vtex30.b8441165.png";